import { render } from "./PaperPlane.vue?vue&type=template&id=164ff629"
import script from "./PaperPlane.vue?vue&type=script&lang=js"
export * from "./PaperPlane.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__